import { useState, useEffect } from 'react';
import request from '../../../../../../lib/request';

const EmailNotification = ({ icon = null, notificationSetting }) => {
  const [isNotificationEnabled, setIsNotificationEnabled] = useState(false);

  useEffect(() => {
    setIsNotificationEnabled(notificationSetting.email);
  }, [notificationSetting.email]);

  const toggleNotification = async () => {
    try {
      const { result } = await request.put('/user/notification', {
        email: !isNotificationEnabled,
      });

      if (result) {
        setIsNotificationEnabled(result.email);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className='flex items-center py-4 border-b gap-2'>
      <div className='flex-1'>
        <div className='flex items-center gap-1'>
          {icon}
          <h2 className='text-sm font-semibold text-gray-900'>
            Email Notifications
          </h2>
        </div>
        <p className='text-sm text-gray-500'>
          Receive email updates, news, and promotions from The Champs.
        </p>
      </div>
      <button
        type='button'
        role='switch'
        aria-checked={isNotificationEnabled}
        onClick={toggleNotification}
        className={`${
          isNotificationEnabled ? 'bg-black' : 'bg-gray-200'
        } relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out  focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2`}
      >
        <span
          aria-hidden='true'
          className={`${
            isNotificationEnabled ? 'translate-x-5' : 'translate-x-0'
          } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}
        />
      </button>
    </div>
  );
};

export default EmailNotification;
